import { MobileContactSheetContext } from './MobileContactSheetContext';
import { useContext } from 'react';

export const useMobileContactSheet = () => {
  const contactSheet = useContext(MobileContactSheetContext);

  return contactSheet;
};
